<template>
  <ion-card id="temps-forts">
    <ion-card-header>
      <ion-card-title>Invités - Hôtes d'honneur</ion-card-title>
    </ion-card-header>
    <ion-card-content class="intro">
      <h2><strong>Métiers autour du cheval</strong></h2>
      <p>
        Cette année, notre salon met à l’honneur les métiers du cheval !
        Si tu es passionné par les animaux, la nature ou le sport, viens explorer un univers où la passion se transforme en vocation.
        Tu pourras en apprendre plus sur les formations, les compétences à acquérir et les possibilités d’avenir qu’offre ce domaine unique.
      </p>
      <NavigateButton id-ilot="66">Emplacement du stand</NavigateButton>

      <h2><strong>Ville hôte</strong></h2>
      <p>Ville invitée du Salon de la formation, Saint-Imier
        présentera les multiples énergies de son territoire: la
        formation et les entreprises formatrices, un tissu
        économique dynamique, un cadre naturel préservé et
        une vie culturelle et sportive active. Une invitation à
        découvrir une terre d’énergies où l’on apprend, entre
        prend, vit et bouge.</p>
      <ion-button
          color="primary"
          href="https://www.saint-imier.ch/"
      >
        <ion-icon :icon="linkSharp" slot="start"></ion-icon>
        <ion-label>saint-imier.ch</ion-label>
      </ion-button>
<!--
      <h1><br>Nécessaire ? -> </h1>

      <h2>Pour le Jura</h2>
      <ion-button
          color="primary"
          href="https://www.ortraju.ch/fr/Accueil/OrTra-jurassienne-sante-social.html"
      >
        <ion-icon :icon="linkSharp" slot="start"></ion-icon>
        <ion-label>ortraju.ch</ion-label>
      </ion-button>

      <h2>Berne francophone</h2>
      <ion-button
          color="primary"
          href="https://www.ortra-bef-s2.ch/index.php"
      >
        <ion-icon :icon="linkSharp" slot="start"></ion-icon>
        <ion-label>ortra-bef.ch</ion-label>
      </ion-button>
-->
    </ion-card-content>
  </ion-card>
</template>

<script>
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonButton,
  IonLabel,
  IonIcon, IonCardTitle
} from '@ionic/vue'

import {
  linkSharp,
} from 'ionicons/icons'
import NavigateButton from "@/components/NavigateButton";


export default {
  name: 'Orientations',
  setup() {
    return { linkSharp };
  },
  components: {
    IonCardTitle,
    NavigateButton,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonButton,
    IonLabel,
    IonIcon
  },
}
</script>

<style scoped lang="sass">
ion-card

  ion-card-header
    margin-bottom: 1rem
    padding-bottom: 0

    ion-card-subtitle
      font-size: 1rem
      color: var(--ion-color-primary)

  h2
    font-size: 1.5rem
    color: var(--ion-color-dark)
    margin: 1.5rem 0 .25rem

  h3
    font-size: 1.1rem
    margin: 0 0 .75rem

  p
    margin: .5rem 0
    font-size: 1rem
</style>
